











































import Vue from "vue";
import pxCard from "@/dex-shared/components/px-card.vue";
import pxButton from "@/dex-shared/components/px-button.vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  components: {
    pxCard,
    pxButton
  },

  computed: {
    ...mapGetters({
      user: "currentUser"
    })
  },

  data() {
    return {
      updating: false
    };
  },

  methods: {
    editProfile: async function() {
      if (this.user.firstName != "" && this.user.lastName != "") {
        this.updating = true;
        await this.$store.dispatch("UPDATE_USER", this.user);
        this.$store.dispatch("VALIDATE");
        this.updating = false;
      }
    }
  }
});
